import axios from "../api";
import { CRYPTO_TOKEN_SECRET_KEY } from "../config";
import CryptoJS from "crypto-js";

const getAuthToken = () => {
    const decryptedData = CryptoJS.AES.decrypt(
        localStorage.getItem("token"),
        CRYPTO_TOKEN_SECRET_KEY
    ).toString(CryptoJS.enc.Utf8);
    return decryptedData;
};

export const getAllBlockedIpsAction = (page = 1, searchValue = "", pageSize = 25) => {
    return new Promise((resolve, reject) => {
        axios
            .get(`/api/ip-blocked?page=${page}&searchValue=${searchValue}&pageSize=${pageSize}`, {
                headers: { Authorization: `Bearer ${getAuthToken()}` },
            })
            .then((response) => resolve(response.data.data))
            .catch((error) => reject(error));
    });
};

export const deleteBlockedIpAction = (id) => {
    return new Promise((resolve, reject) => {
        axios
            .delete(`/api/ip-blocked/${id}`, {
                headers: { Authorization: `Bearer ${getAuthToken()}` },
            })
            .then((response) => resolve(response.data))
            .catch((error) => reject(error));
    });
};
